import styled from 'styled-components';
import { withOmitProps } from '../helpers/elements';
import { svgColorStyle, svgDisplayStyle, svgKeys, svgPointerStyle, svgSizeStyle } from './style';
import { baseHighlightStyle } from '../tokens/highlight';

// Component to be used 'as' an SVG element
// e.g. <Icon as={LocationIcon} size={24} color={'#000'} />
const Icon = styled.span.withConfig(withOmitProps(svgKeys))`
  ${baseHighlightStyle}
  ${svgDisplayStyle}
  ${svgSizeStyle}
  ${svgColorStyle}
  ${svgPointerStyle}
`;
export default Icon;